import { render, staticRenderFns } from "./CaseLabelDialog.vue?vue&type=template&id=63156d48&scoped=true"
import script from "./CaseLabelDialog.vue?vue&type=script&lang=js"
export * from "./CaseLabelDialog.vue?vue&type=script&lang=js"
import style0 from "./CaseLabelDialog.vue?vue&type=style&index=0&id=63156d48&prod&scoped=true&lang=css"
import style1 from "./CaseLabelDialog.vue?vue&type=style&index=1&id=63156d48&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63156d48",
  null
  
)

export default component.exports